export enum PostAssignmentPromptType {
  transcriptSearch = 'transcript_search',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const PostAssignmentPromptTypeMap = {
  transcript_search: PostAssignmentPromptType.transcriptSearch,
}

export const PostAssignmentPromptTypeReverseMap = {
  [PostAssignmentPromptType.transcriptSearch]: 'transcript_search',
}

export const PostAssignmentPromptTypeList = [
  PostAssignmentPromptType.transcriptSearch,
]

export const PostAssignmentPromptTypeNames = Object.keys(
  PostAssignmentPromptTypeMap
)
